<template>
  <div class="app">
    <slot />
  </div>
</template>

<script setup lang="ts"></script>

<style lang="scss"></style>
